import appConfig from "./app.config.value";

export default defineAppConfig(appConfig)